const BOOKING_CUSTOMER_DEFAULT = {
  address1: '',
  address2: '',
  address3: '',
  address4: '',
  address5: '',
  address6: '',
  address7: '',
  address8: '',
  address9: '',
  address10: '',
  country: 'my',
  customerDetailID: null,
  customerID: null,
  customer: {
    icFrontDocumentID: '',
    icFrontDocument: null,
    icBackDocumentID: '',
    icBackDocument: null,
    specifications: [],
    taxIdentificationNo: '',
    taxTinValidationStatus: null,
    isForeignCompany: false,
  },
  signAt: '',
  email: '',
  identity: '',
  identityTypeID: null,
  identityPresetID: '',
  identityPresetLabel: '',
  identityPresetRegex: '',
  prsID: '',
  mobile: '',
  mobilePrefix: '60',
  name: '',
  phone: '',
  phonePrefix: '60',
  preferredName: '',
  title: '',
  jobTitle: '',
  monthlyIncome: '',
  nationality: '',
  citizenship: '',
  gender: '',
  race: '',
  raceOther: '',
  bumi: 'Not Applicable',
  maritalStatus: '',
  relationshipType: '',
  birthdate: '',
  buyerProfileID: '',
  buyerICFront: '',
  buyerICBack: '',
  emergencyContactName: '',
  emergencyContactRelation: '',
  emergencyContactMobilePrefix: '60',
  emergencyContactMobile: '',
  emergencyContactEmail: '',
  emergencyContactIdentity: '',
  externalID: '',
  originCustomerID: '',
};
export default BOOKING_CUSTOMER_DEFAULT;



// WEBPACK FOOTER //
// ./src/structs/booking_customer.js